import { CapoPlugin } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105104241Z/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];